import { useContext, useEffect, useRef } from 'react';
import ApplicationContext from '../ApplicationContext';

let countCheck = 0;

export default function useListHeightMonitor(name:string) {
  const appContext = useContext(ApplicationContext);
  
  useEffect(() => {
    initialize();

    return uninitialize;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  
  useEffect(() => {
    adjustTableHeight();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appContext.appInfoAreaDrawerHeight, appContext.appInfoAreaContent]);

  const observer = useRef<MutationObserver|null>(null);
  const infoAreaVisibleRef = useRef(false);
  const scrollPos = useRef(0);

  function initialize() {
    initializeEventListeners();
    initializeObserver();
  }

  function uninitialize() {
    uninitializeObserver();
    uninitializeEventListeners();
  }

  function initializeEventListeners() {
    window.addEventListener('resize', onScreenResize);
  }

  function uninitializeEventListeners() {
    window.removeEventListener('resize', onScreenResize);
  }

  function initializeObserver() {
    if (observer && observer.current) {
      return;
    }

    const appContentNode = document.getElementById('ifms-app-content');
    if (!appContentNode) {
      return;
    }

    const observerConfig = {
      attributes: true,
      childList: true,
      subtree: true,
      attributeFilter: [],
    };

    observer.current = new MutationObserver(observe);
    observer.current.observe(appContentNode, observerConfig);
  }

  function uninitializeObserver() {
    if (observer && observer.current) {
      observer.current.disconnect();
    }
  }

  function onScreenResize() {
    adjustTableHeight();
  }

  function observe() {
    // HACK - to avoid infinite loop in typescript. Research and find proper solution

    if (countCheck >= 100) {
      countCheck = 0;
      return;
    }
    
    ++countCheck;
    adjustTableHeight();
  }

  function adjustTableHeight() {
    const infoArea = document.getElementById('ifms-info-area-drawer');

    if (!infoAreaVisibleRef.current && infoArea && infoArea.dataset.open === 'true') {
      setTimeout(() => {
        captureTableScrollPosition();
        doAdjustTableHeight();
        scrollSelectedTableRowIntoView();
      }, 200); // To handle animations propely
    } else {
      const infoAreaWasOpened = !!infoAreaVisibleRef.current && infoArea && infoArea.dataset.open === 'false';
      doAdjustTableHeight();

      if (infoAreaWasOpened) {
        restoreTableScrollPosition();
      }
    }
  }

  function restoreTableScrollPosition() {
    const table = document.getElementById(name);
    if (!table) {
      return;
    }

    table.scrollTo({
      top: scrollPos.current,
      behavior: 'smooth'
    });
  }

  function captureTableScrollPosition() {
    const table = document.getElementById(name);
    if (!table) {
      return;
    }

    scrollPos.current = table.scrollTop;
  }

  function scrollSelectedTableRowIntoView() {
    const table = document.getElementById(name);
    if (!table) {
      return;
    }

    const selectedRows = table.getElementsByClassName('data-row-selected');
    if (!selectedRows || selectedRows.length <= 0) {
      return;
    }

    const selectedRow = selectedRows[0];

    selectedRow.scrollIntoView({behavior: 'smooth', block: 'end'});
  }

  function doAdjustTableHeight() {
    const table = document.getElementById(name);
    if (!table) {
      return;
    }

    const tableScrollbarHeight = table.getBoundingClientRect().height - table.clientHeight;

    let titleBarHeight = 0;
    let infoAreaHeight = 0;
    let pagerHeight = 79;

    const titleBars = document.getElementsByClassName(!appContext.useDarkMode ? 'ifms-screen-title-bar' : 'ifms-screen-title-bar-darkmode');
    if (titleBars && titleBars.length > 0) {
      var tbRect = titleBars[0].getBoundingClientRect();
      titleBarHeight = tbRect.bottom;
    }

    const infoArea = document.getElementById('ifms-info-area-drawer');
    if (infoArea && infoArea.dataset.open === 'true') {
      infoAreaHeight = infoArea.clientHeight - tableScrollbarHeight; // In case info area is open don't make list appear above info area
      infoAreaVisibleRef.current = true;
    } else {
      infoAreaVisibleRef.current = false;
    }

    const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

    table.style.height = infoAreaVisibleRef.current ? `${vh - titleBarHeight - infoAreaHeight - 19 - pagerHeight}px` : `${vh - titleBarHeight - infoAreaHeight - pagerHeight}px`;
  }

  return {
  };
}
  